import register from 'preact-custom-element'
import { WishlistDrawer } from './WishlistDrawer'

register(WishlistDrawer, 'x-wishlist-drawer')
